const transitionTypeData = ['fadeInFadeOut'];

export default transitionTypeData;
